<script lang="ts">
  import { onMount } from "svelte";
  import { PublicClientApplication } from "@azure/msal-browser";
  import { handleSuccessfulAuth, redirectUrl } from "../services/security/auth-handler.js";
  import { Label } from "flowbite-svelte";
  import { getEnvironment } from "../config/env.js";
  import { logError } from "../services/logging/log-handler.js";

  const config = getEnvironment();

  const msalConfig = {
    auth: {
      clientId: config.clientId ?? "",
      authority: "https://openhgappdev.b2clogin.com/openhgappdev.onmicrosoft.com/B2C_1_PwdReset",
      knownAuthorities: config.knownAuthorities ?? [],
      redirectUri: config.redirectUri ?? "",
      navigateToLoginRequestUrl: config.navigateToLoginRequestUrl ?? false,
      validateAuthority: false,
      postLogoutRedirectUri: config.redirectUri ?? "",
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  };
  const msalInstance = new PublicClientApplication(msalConfig);

  onMount(async () => {
    if (!config.useB2C) {
      logError(new Error("B2C authentication is not enabled"), "PasswordResetB2C", undefined);
      return;
    }
    await msalInstance.initialize();
    const response = await msalInstance.handleRedirectPromise();
    if (!response) {
      try {
        await msalInstance.loginRedirect({
          scopes: ["openid", "profile"],
          prompt: "login",
        });
      } catch (error) {
        logError(error, "PasswordResetB2C", undefined, { message: "Password reset failed" });
      }
    } else {
      // After successful password reset, redirect to login
      window.location.href = "/login";
    }
  });
</script>

<div class="login-page">
  <div class="login-container">
    <Label>One moment, redirecting to password reset...</Label>
  </div>
</div>
